import React, { useState } from 'react'
import starIcon from '../../assets/images/star-icon.png'
import contact from '../../assets/images/contact.png'
import Img from "gatsby-image"
import serialize from 'form-serialize';
import axios from "axios"



const ContactForm = (props) => {
    const data = props.data

    const [emailResponse, setEmailResponse] = useState("");

    const [loading, setLoading] = useState(false);

    function contactMessage(e) {
        e.preventDefault();
        if (!loading) {
            setLoading(true)
            let form = document.querySelector('#contactForm');
            let str = serialize(form, { hash: true });
            str.lang = props.lang;
            console.log(str)
            axios.post(`https://admin.w3vitals.com/wp-json/myplugin/v1/contactEmail`, str)
                .then(function (response) {
                    setEmailResponse(response.data)

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'contact_form_submission'
                    });

                    setLoading(false)
                })
                .catch(function (error) {
                    setLoading(false)
                })
        }
    }


    return (
        <section className="contact-area pb-100" id="contact-form">
            <div className="container">

                { props.staticForm
                    ?
                    <div className="section-title">
                        <span className="sub-title" style={{ color: "#DB3A00" }}>
                            {props.serviceData ? props.serviceData.subtitle : data.form.subTitle}
                        </span>
                        <h2>Δήλωση ενδιαφέροντος</h2>
                    </div>
                    :

                    <div className="section-title">
                        <span className="sub-title" style={{ color: "#DB3A00" }}>
                            {props.serviceData ? props.serviceData.subtitle : data.form.subTitle}
                        </span>
                        <h2>{props.temp ? props.temp.title : (props.serviceData ? props.serviceData.title : data.form.title)}</h2>
                        <p>{props.serviceData ? props.serviceData.description : data.form.content}</p>
                    </div>
                }

                <div className="row">
                    <div className="col-lg-6 col-md-12">
                        <div className="contact-image">
                            <Img fluid={data.image.imageFile.childImageSharp.fluid} alt={data.image.altText} />
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-12">
                        {emailResponse === "" && (
                            <div className="contact-form">
                                <form id="contactForm" onSubmit={(e) => contactMessage(e)}>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-6">
                                            <div className="form-group">
                                                <label style={{ color: "#757575", fontWeight: "700" }} for="form-name">{data.form.fullName}</label>
                                                <input id="form-name" type="text" name="name" className="form-control" required />
                                            </div>
                                        </div>

                                        <div className="col-lg-12 col-md-6">
                                            <div className="form-group">
                                                <label style={{ color: "#757575", fontWeight: "700" }} for="form-email">{data.form.email.label}</label>
                                                <input id="form-email" type="email" name="email" className="form-control" required />
                                            </div>
                                        </div>

                                        <div className="col-lg-12 col-md-12">
                                            <div className="form-group">
                                                <label style={{ color: "#757575", fontWeight: "700" }} for="form-phone">{data.form.telephone.label}</label>
                                                <input id="form-phone" type="text" name="phone_number" className="form-control" />
                                            </div>
                                        </div>

                                        <div className="col-lg-12 col-md-12">
                                            <div className="form-group">
                                                <label style={{ color: "#757575", fontWeight: "700" }} for="form-subject">{data.form.message.label}</label>
                                                <textarea id="form-subject" name="message" className="form-control" cols="30" rows="6" required />
                                            </div>
                                        </div>

                                        <div className="col-lg-12 col-md-12">
                                            <button type="submit" className="default-btn">
                                                {!loading ?
                                                    <>
                                                        <span style={{ position: "absolute", left: "20px" }}>✓</span>
                                                        {data.form.sendButton} <span></span>
                                                    </>
                                                    :
                                                    props.lang === "EN" ? "Loading" : (props.lang === "EL" ? "Αναμονή" : "Chargement")
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        )}
                        {emailResponse !== "" && (
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div dangerouslySetInnerHTML={{ __html: emailResponse }}></div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactForm